angular.module('dpw.components')
    .component('dpwProductFilterGroup', {
        bindings: {
            type: '@',
            heading: '@',
            expanded: '<'
        },
        templateUrl: 'dpw-product-filter-group.html',
        transclude: true,
        controller: [function () {
            var self = this;

            self.isPrimary = function () {
                return self.type === 'primary';
            };

            self.isSecondary = function () {
                return self.type === 'secondary';
            };
        }]
    });
